module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_vm._v("会员卡促销")]), _vm._v(" "), _c('div', {
    staticClass: "search-wrapper"
  }, [_c('el-form', {
    staticClass: "search-row",
    attrs: {
      "inline": true,
      "model": _vm.queryParam,
      "label-width": "82px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "适用会员卡"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "全部"
    },
    model: {
      value: (_vm.queryParam.cardId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "cardId", $$v)
      },
      expression: "queryParam.cardId"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": 0
    }
  }), _vm._v(" "), _vm._l((_vm.cardOptions), function(card) {
    return _c('el-option', {
      key: card.id,
      attrs: {
        "label": ((card.name) + "（ID:" + (card.id) + "）"),
        "value": card.id
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "140px"
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "未开始",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "进行中",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已结束",
      "value": 3
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "search-action-item"
  }, [_c('el-button', {
    on: {
      "click": _vm.clickReset
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickSearch
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "summary-wrapper"
  }, [_c('div', {
    staticClass: "summary-item"
  }, [_c('span', {
    staticClass: "summary-label"
  }, [_vm._v("累计销量")]), _vm._v(" "), _c('span', {
    staticClass: "summary-value"
  }, [_vm._v(_vm._s(_vm.summary.totalSales != null ? _vm.summary.totalSales : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "summary-item"
  }, [_c('span', {
    staticClass: "summary-label"
  }, [_vm._v("累计收入")]), _vm._v(" "), _c('span', {
    staticClass: "summary-value"
  }, [_vm._v(_vm._s(_vm.summary.totalIncome != null ? _vm.formatYuan(_vm.summary.totalIncome) : "--"))])]), _vm._v(" "), _c('el-button', {
    staticClass: "summary-add-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickCreateSale
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('el-table', {
    ref: "promotionTable",
    attrs: {
      "data": _vm.listData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "活动ID",
      "min-width": "95",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "activityName",
      "label": "活动名称",
      "min-width": "160",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "促销时间",
      "min-width": "320"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(row.promoTimeText))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "适用会员卡",
      "min-width": "170"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(row.cardName) + "（ID:" + _vm._s(row.cardId) + "）")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "售卖价",
      "min-width": "110",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(row.salePriceText))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "活动限购",
      "min-width": "130",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(row.purchaseLimitText))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "适用人群",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.audiences && row.audiences.length) ? _c('div', _vm._l((row.audiences), function(aud, i) {
          return _c('div', {
            key: i,
            staticClass: "audience-line"
          }, [_vm._v("\n              " + _vm._s(aud) + "\n            ")])
        }), 0) : _c('span', [_vm._v("--")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "topTag",
      "label": "顶部标签",
      "min-width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "底部标签",
      "min-width": "150",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.bottomTagType === 2) ? _c('span', [_vm._v(_vm._s(_vm.countdownText(row.endTime)))]) : _c('span', [_vm._v(_vm._s(row.bottomTag))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "促销价",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.promotionPriceText))]), _vm._v(" "), (row.discountText) ? _c('span', {
          staticClass: "discount-text"
        }, [_vm._v(_vm._s(row.discountText))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "salesCount",
      "label": "活动销量",
      "min-width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "salesRevenue",
      "label": "活动收入",
      "min-width": "130",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "min-width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-tag', {
          attrs: {
            "type": _vm.statusTagType(row.status)
          }
        }, [_vm._v(_vm._s(row.statusText))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createdAtText",
      "label": "创建时间",
      "min-width": "170",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "280",
      "align": "center",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.clickView(row)
            }
          }
        }, [_vm._v("查看促销")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.clickEdit(row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.clickCopy(row)
            }
          }
        }, [_vm._v("复制")]), _vm._v(" "), (row.status !== 3) ? _c('el-button', {
          staticStyle: {
            "color": "#f56c6c"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.clickEnd(row)
            }
          }
        }, [_vm._v("立即结束")]) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total > 0),
      expression: "total > 0"
    }],
    staticClass: "pagination-seq"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "current-page": _vm.queryParam.pageNum,
      "page-size": _vm.queryParam.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.changeCurrentPage
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-27b4b16a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/UserAdminister/MemberPromotion/MemberPromotion.vue
// module id = 973
// module chunks = 0